import { Technology } from '../interfaces/technology.interface';

export const technologies: {[name: string]: Technology} = {
  ANGULAR: {
    name: 'Angular',
    logo: '/assets/images/technologies/angular.svg'
  },
  BOOTSTRAP: {
    name: 'Bootstrap',
    logo: '/assets/images/technologies/bootstrap.svg'
  },
  JAVASCRIPT: {
    name: 'Javascript',
    logo: '/assets/images/technologies/javascript.svg'
  },
  LARAVEL: {
    name: 'Laravel',
    logo: '/assets/images/technologies/laravel.svg'
  },
  PHP: {
    name: 'PHP',
    logo: '/assets/images/technologies/php.svg'
  },
  SEMANTICUI: {
    name: 'Semantic UI',
    logo: '/assets/images/technologies/semantic-ui.svg'
  },
  WORDPRESS: {
    name: 'Wordpress',
    logo: '/assets/images/technologies/wordpress.svg'
  },
  TAILWINDCSS: {
    name: 'Tailwindcss',
    logo: '/assets/images/technologies/tailwindcss.svg'
  },
  NODEJS: {
    name: 'Nodejs',
    logo: '/assets/images/technologies/nodejs.svg'
  }
};